/**
 * @file types/shared.ts
 *
 * @description Type definitions related to business logic that might be used by multiple different views/modules.
 *
 */

/**
 * Enum for sorting order.
 *
 * @enum {string}
 * @readonly
 */
export const enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

/**
 * Enum for different sim statuses in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {number}
 * @readonly
 */
export const enum SimStatus {
  ACTIVE = 10,
  ACTIVATION_IN_PROGRESS = 12,
  INACTIVE = 0,
  PAUSED = 99,
  SWAPPED = 9,
  ACTIVATION_FAILED = 90,
  DEACTIVATED = 11,
}

/**
 * Enum for different sim types in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {string}
 * @readonly
 */
export const enum SimType {
  SPR = 'spr',
  FIXED = 'fixed',
}

/**
 * Enum for different portin request statuses in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {string}
 * @readonly
 */
export const enum PortInRequestStatus {
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  FAILED = 'failed',
  RESOLUTION_REQUIRED = 'resolution_required',
}

/**
 * Enum for different order statuses in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {number}
 * @readonly
 */
export enum OrderStatus {
  CANCELLED = 11,
  COMPLETED = 10,
  PENDING = 0,
}

/**
 * Enum for different order actions in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {string}
 * @readonly
 */
export enum OrderAction {
  Approve = 'Approve',
  Reject = 'Reject',
}

/**
 * Enum for different order types in the system. Should be in sync with the backend (iot-api).
 *
 * @enum {string}
 * @readonly
 */
export enum OrderType {
  SPR = 'spr',
  FIXED = 'fixed',
  ESIM = 'eSIM',
}

/**
 * Enum for user roles within the system. Should be in sync with the backend (iot-api).
 *
 * @enum {string}
 * @readonly
 */
export enum UserRole {
  SUB_USER = 'sub_user',
  SUPER_ADMIN = 'superadmin',
  ADMIN = 'admin',
  SYSOPS = 'sysops',
  SPR_PARTNER = 'spr_partner',
  USER = 'user',
}
